const createHeaderItem = data => ({
  name: data.name || 'Bilyoner Lig Merkezi',
  link: data.slug || '/lig-merkezi',
  selectable: true,
  tag: null,
  isHeader: true
});

const createCategoryItem = category => ({
  name: category.name,
  link: '/lig-merkezi',
  selectable: false,
  tag: category.tag || null,
  color: category.highlightsColor || '#18AA52',
  icon: category.icon || null,
  isCategory: true,
});

const createLeagueItem = league => {
  let slug = league.slug || '';
  if (slug.startsWith('/')) slug = slug.substring(1);
  slug = slug.replace('lig-merkezi/', '');
  return {
    name: league.leagueName || league.title,
    link: `/lig-merkezi/${slug}`,
    slug,
    color: league.highlightsColor || '#FF0000',
    tag: league.tag || null,
    icon: league.icon || null,
    isSubItem: true,
    hasTeams: Boolean(league.teams?.length > 0)
  };
};

const createTeamItem = (team, league) => {
  let teamSlug = team.slug || '';
  if (teamSlug.startsWith('/')) teamSlug = teamSlug.substring(1);
  teamSlug = teamSlug.replace('lig-merkezi/', '');
  let leagueSlug = league.slug || '';
  if (leagueSlug.startsWith('/')) leagueSlug = leagueSlug.substring(1);
  leagueSlug = leagueSlug.replace('lig-merkezi/', '');

  return {
    name: team.teamName || team.title,
    link: `/lig-merkezi/${leagueSlug}/${teamSlug}`,
    slug: teamSlug,
    leagueSlug,
    leagueName: league.leagueName || league.title,
    widgetsSlug: team.widgets[0]?.slug || `lig-merkezi/${teamSlug}/puan-durumu`,
    color: team.color || '#666666',
    tag: team.tag || null,
    icon: team.icon || null,
    isTeam: true
  };
};

export const createNavigationItems = data => {
  if (!data) return [];
  const navigationItems = [];
  navigationItems.push(createHeaderItem(data));
  
  data?.leagues?.forEach(category => {
    if (!category.active) return;
    
    if (category.name === 'Canlı Yayin Rehberi' || category.name === 'Canlı Yayın Rehberi') {
      navigationItems.push({ isDivider: true });
      navigationItems.push({
        name: 'Canlı Yayın Rehberi',
        link: '/lig-merkezi/canli-yayin-rehberi',
        selectable: true,
        tag: category.tag || null,
        color: category.highlightsColor || '#18AA52',
        icon: category.icon || null,
        isCategory: true
      });
    } else {
      navigationItems.push(createCategoryItem(category));
      if (category.leagues?.length > 0) {
        category.leagues.forEach(league => {
          if (!league.active) return;
          navigationItems.push(createLeagueItem(league));
          if (league.teams?.length > 0) {
            league.teams.forEach(team => {
              navigationItems.push(createTeamItem(team, league));
            });
          }
        });
      }
    }
  });
  
  return navigationItems;
};
